import React from 'react';

import { Button } from '@jimdo/ui';

import { PlaceholderImage } from '../placeholder-image/placeholderImage';
import { breakpoints } from '../../modules/constants';
import { TemplateImage } from '../../modules/templateImages';
import Tile from '../tile/tile';

import './templateListElement.scss';

export type TemplateSelectionCallback = (subtype: string) => void;

interface Props {
  onSelect: TemplateSelectionCallback;
  buttonText: string;
  image: TemplateImage;
  subtype: string;
}

const handleClick = (props: Props) => (): void => {
  props.onSelect(props.subtype);
};

const TemplateListElement: React.FC<Props> = (props: Props) => {
  return (
    <li className="templatelist-element-component">
      <Tile className="templatelist-element-component__tile" onClick={handleClick(props)}>
        <PlaceholderImage
          image={props.image}
          sizes={`
                (min-width: ${breakpoints.largeDesktop}) 420px,
                (min-width: ${breakpoints.mediumDesktop}) 350px,
                (min-width: ${breakpoints.mobileMedium}) 48vw,
                420px
            `}
        />
        <div className="templatelist-element-component__footer--mobile">
          {props.buttonText}
        </div>
        <div className="templatelist-element-component__overlay--desktop">
          <Button buttonStyle="primary" noGutter={false}>
            {props.buttonText}
          </Button>
        </div>
      </Tile>
    </li>
  );
};

export default TemplateListElement;
